import React from "react";

export default function UserSvg(): React.JSX.Element {
  return (
    <svg viewBox="0 0 20 24" id="huser" width="20" height="24" aria-describedby="user">
      <g fill="none">
        <g stroke="black" strokeWidth="2">
          <path
            d="M12 14H6c-3.314 0-6 2.686-6 6v1s3.125 1 9 1 9-1 9-1v-1c0-3.314-2.686-6-6-6zM4 5c0-2.761 2.239-5 5-5s5 2.239 5 5-2.239 6-5 6-5-3.239-5-6z"
            transform="translate(-299 -65) translate(300 66)"
          />
        </g>
      </g>
    </svg>
  );
}
